<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => switchShowData()">{{
          showChart ? '列表' : '图表'
        }}</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="reportActionBO.ajax?cmd=orgMonthlyReport"
          :params="fullSearchData"
          bizName="部门运营月报表"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" showAttrName="showThisChild" />
      </qx-permpisions>
    </section>
    <section class="tablePage" v-show="!showChart">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          :data="tableData.data"
          class="expand-label-box"
          :height="tableHeight"
        >
          <template v-for="(item, index) in tableData.title">
            <!-- 常规列表项 -->
            <el-table-column
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.width || 150"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.showThisChild !== false"
              :label-class-name="
                item.insertParent
                  ? 'expand-parent'
                  : item.parent
                  ? 'expand-child'
                  : ''
              "
              align="center"
            >
              <template slot="header">
                <span v-if="item.insertParent">
                  {{ item.label }}
                  <i
                    :class="`el-icon-${item.iconOpen ? 'minus' : 'plus'} cur`"
                    @click="handleShowMore(item, index)"
                  />
                </span>
              </template>
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'grossProfitMargin'">
                  {{ scope.row.grossProfitMargin * 100 }}
                </section>
                <section v-else-if="scope.column.property === 'netProfitRatio'">
                  {{ scope.row.netProfitRatio * 100 }}
                </section>
                <section v-else>
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <div
      style="opacity: 0; height: 1px; background: #ffffff"
      id="placeholderDiv"
    ></div>
    <section style="min-height: 250px" v-show="showChart">
      <section v-show="searchData.mode === 1">
        <Order ref="org" :width="placeholderDiv + 'px'" />
      </section>
      <section class="order-chart-box" v-show="searchData.mode === 2">
        <Order ref="month" :width="placeholderDiv + 'px'" />
      </section>
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import Order from './order';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  orgMonthlyReport,
} from 'api/report';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    Order,
    TableSetting,
  },
  data () {
    return {
      showChart: false,
      searchData: {},
      placeholderDiv: 0,
      tableData: { // 表格相关数据
        loading: false,
        rows: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        // title: tableHeaderData.normal,
        title: [
          { prop: 'feeTime', label: '月份', fixed: 'left', width: 100 },
          { prop: 'orderNum', label: '订单数量', width: 80 },
          { prop: 'incomeFee', label: '订单收入' },
          { prop: 'orderCost', label: '订单成本' },
          { prop: 'oilFee', label: '油费' },
          { prop: 'etcFee', label: '过路费' },
          // 运费
          { prop: 'freightFee', label: '运费', insertParent: 'freightFee', iconOpen: false },
          { prop: 'advanceFee', label: '预付现金', parent: 'freightFee', showThisChild: false },
          { prop: 'collect', label: '到付现金', parent: 'freightFee', showThisChild: false },
          { prop: 'finalFee', label: '尾款', parent: 'freightFee', showThisChild: false },
          { prop: 'premiumFee', label: '保费', parent: 'freightFee', showThisChild: false },
          // 异常费用
          { prop: 'abnormalFee', label: '异常费用', insertParent: 'abnormalFee', iconOpen: false },
          { prop: 'unusualFee', label: '异常费用', parent: 'abnormalFee', showThisChild: false },
          { prop: 'agingFee', label: '时效罚款', parent: 'abnormalFee', showThisChild: false },
          // 其他订单费
          { prop: 'otherFee', label: '其他订单费', insertParent: 'otherFee', iconOpen: false },
          { prop: 'parkingFee', label: '停车费', parent: 'otherFee', showThisChild: false },
          { prop: 'maintenanceFee', label: '维修费', parent: 'otherFee', showThisChild: false },
          { prop: 'upkeepFee', label: '保养费', parent: 'otherFee', showThisChild: false },
          { prop: 'tireFee', label: '轮胎费', parent: 'otherFee', showThisChild: false },
          // 车辆固定费用
          { prop: 'fixedFee', label: '车辆固定费用', insertParent: 'fixedFee', iconOpen: false },
          { prop: 'annualFee', label: '年审费', parent: 'fixedFee', showThisChild: false },
          { prop: 'vpremiumFee', label: '保险费', parent: 'fixedFee', showThisChild: false },
          { prop: 'gpsFee', label: 'GPS费', parent: 'fixedFee', showThisChild: false },
          { prop: 'rentalFee', label: '车辆租金', parent: 'fixedFee', showThisChild: false },
          { prop: 'depreciationFee', label: '折旧', parent: 'fixedFee', showThisChild: false },
          // 车辆维护费用
          { prop: 'vmaintenanceFee', label: '车辆维护费用', insertParent: 'vmaintenanceFee', iconOpen: false },
          { prop: 'vparkingFee', label: '停车费', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'ureaFee', label: '尿素费', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'fmaintenanceFee', label: '维修费', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'vupkeepFee', label: '保养费', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'vtireFee', label: '轮胎费', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'breakFee', label: '违章', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'accidentFee', label: '事故', parent: 'vmaintenanceFee', showThisChild: false },
          { prop: 'votherFee', label: '其他车辆费', parent: 'vmaintenanceFee', showThisChild: false },
          // 车辆维护费用 - end
          { prop: 'revenueFee', label: '其他收入' },
          { prop: 'grossProfitMargin', label: '毛利率（%）' },
          { prop: 'grossMargin', label: '毛利' },
          { prop: 'financial', label: '财务费用' },
          // 管理费用
          { prop: 'adminFee', label: '管理费用', insertParent: 'adminFee', iconOpen: false },
          { prop: 'employeeFee', label: '员工薪酬', parent: 'adminFee', showThisChild: false },
          { prop: 'officeFee', label: '办公费', parent: 'adminFee', showThisChild: false },
          { prop: 'entertainmentFee', label: '招待费', parent: 'adminFee', showThisChild: false },
          { prop: 'travelFee', label: '差旅费', parent: 'adminFee', showThisChild: false },
          { prop: 'massFee', label: '团建费', parent: 'adminFee', showThisChild: false },
          { prop: 'rentFee', label: '房租水电费', parent: 'adminFee', showThisChild: false },
          { prop: 'consultingFee', label: '咨询费', parent: 'adminFee', showThisChild: false },
          { prop: 'otherFee', label: '其他费', parent: 'adminFee', showThisChild: false },
          { prop: 'interestFee', label: '贷款利息', parent: 'adminFee', showThisChild: false },
          { prop: 'factoringFee', label: '保理利息', parent: 'adminFee', showThisChild: false },
          { prop: 'financialFee', label: '财务费用', parent: 'adminFee', showThisChild: false },
          { prop: 'taxesFee', label: '税金', parent: 'adminFee', showThisChild: false },
          // 管理费用 - end
          { prop: 'netProfitRatio', label: '净利率（%）' },
          { prop: 'netProfit', label: '净利' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orgMonthlyReport,

    handleShowMore (item, index) {
      const newTitle = this.tableData.title;
      newTitle[index].iconOpen = !item.iconOpen;
      for (let i = 0; i < newTitle.length; i++) {
        if (newTitle[i].parent === item.prop) {
          newTitle[i].showThisChild = newTitle[index].iconOpen;
        }
      }
      this.tableData.title = newTitle;
      // this.$forceUpdate();
    },

    switchShowData () {
      this.showChart = !this.showChart;
      this.$emit('getChartData');
    },

    // 获取图表数据
    async getChartData (data) {
      const res = await orgMonthlyReport({
        page: 1,
        // TODO 本来要全部返回，为了快速完成功能所以一次性查10000个
        rows: 10000,
        ...data,
        sts: true,
      });
      let resData = [];
      if (!res.failed) {
        if (res.items && res.items.length) {
          resData = res.items;
        }
      }
      return resData;
    },

    // 提供给外部调用的方法，填入数据
    async setLineChartData (data) {
      this.searchData = data;
      if (this.showChart) {
        const resData = await this.getChartData(data);
        if (data.mode === 1) {
          // 部门对比
          this.setChartData('org', this.handleChartData(resData, 'orgName'));
        }
        if (data.mode === 2) {
          // 月份对比
          this.setChartData('month', this.handleChartData(resData, 'feeTime'));
        }
      }
    },

    /**
     * @param {Object} data       返回的列表数据
     * @param {String} fieldName  围绕着哪个字段来处理数据，如果是 部门对比 ，则是 orgName，月份对比是 dependTime
     * @returns {Object}  返回处理好的图表数据
     * @description 将返回的列表数据格式 转化成 图表数据所需的格式
     */
    handleChartData (data, fieldName) {
      let json = {};
      for (let item of data) {
        Object.keys(item).forEach((itemName) => {
          if (item[fieldName]) {
            let targetItem = item[fieldName] + '_' + itemName;
            if (!json[targetItem]) {
              // 如果没有该月份，则设置一个该月/该部门的属性
              if (!isNaN(Number(item[itemName]))) {
                json[targetItem] = Number(item[itemName]) * 1000;
              }
            } else {
              // 如果已存在，则累加
              if (!isNaN(Number(item[itemName]))) {
                json[targetItem] += Number(item[itemName]) * 1000;
              }
            }
          }
        });
      }

      // 月份/部门
      const xAxisData = [];
      // 各种类型
      const seriesData = [
        { type: 'line', prop: 'orderNum', name: '订单数量', data: [], select: true },
        { type: 'line', prop: 'incomeFee', name: '订单收入（元）', data: [], select: false },
        { type: 'line', prop: 'orderCost', name: '订单成本（元）', data: [], select: false },
        { type: 'line', prop: 'revenueFee', name: '其他收入（元）', data: [], select: false },
        { type: 'line', prop: 'oilFee', name: '油费', data: [], select: false },
        { type: 'line', prop: 'etcFee', name: '过路费', data: [], select: false },
        { type: 'line', prop: 'freightFee', name: '运费（现金）', data: [], select: false },
        { type: 'line', prop: 'otherFee', name: '其他订单费', data: [], select: false },
        { type: 'line', prop: 'salaryFee', name: '司机工资', data: [], select: false },
        { type: 'line', prop: 'fixedFee', name: '车辆固定费用', data: [], select: false },
        { type: 'line', prop: 'adminFee', name: '管理费用', data: [], select: false },
        { type: 'line', prop: 'financialFee', name: '财务费用', data: [], select: false },
        { type: 'line', prop: 'vmaintenanceFee', name: '车辆维护费用', data: [], select: false },
        { type: 'line', prop: 'grossMargin', name: '毛利', data: [], select: false },
        { type: 'line', prop: 'grossProfitMargin', name: '毛利率', data: [], select: false },
      ];

      for (let name in json) {
        if (name && !isNaN(json[name])) {
          const targetName = name.split('_')[0];
          if (!xAxisData.includes(targetName)) {
            // 月份
            xAxisData.push(targetName);
          }
          for (let seriesItem of seriesData) {
            if (name.includes(seriesItem.prop)) {
              // 每一项的数据
              seriesItem.data.push((json[name] / 1000).toFixed(2));
            }
          }
        }
      }

      // 筛选项
      const legendData = seriesData.map((item) => item.name);
      // 默认选中哪个显示项
      let legendSelect = {};
      seriesData.forEach((item) => {
        legendSelect[item.name] = item.select;
      });

      return {
        xAxisData,
        legendData,
        legendSelect,
        seriesData,
      };
    },

    // 设置图表数据用于渲染展示
    setChartData (chartName, chartData) {
      const options = {
        isShowCustomData: true,
        xAxis: {
          type: 'category',
          data: chartData.xAxisData,
        },
        // 图表位置
        grid: {
          left: '10%',
          right: '15%',
          bottom: '10%',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: chartData.legendData,
          orient: 'vertical',
          x: 'right',
          y: 'center',
          selected: chartData.legendSelect,
          textStyle: {
            fontSize: 14,
          },
          itemGap: 12,
        },
        yAxis: {
          type: 'value',
        },
        series: chartData.seriesData,
      };
      this.$refs[chartName].setOptions(options);
    },

    // 设置图表的宽度
    setChartWidth () {
      const placeholderDiv = document.getElementById('placeholderDiv');
      this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      window.onresize = () => (() => {
        this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      })();
    },
  },
  mounted () {
    this.setChartWidth();
  },
};
</script>

<style lang="scss" scoped>
.expand-label-box {
  ::v-deep .expand-parent {
    background: #d5d5d5;
  }
  ::v-deep .expand-child {
    background: #ededed;
  }
}
</style>
